export default __webpack_public_path__ + "static/media/high_availability_icon.dd085c4c.svg";